/*
  let snackbarRef = this.snackBar.openFromComponent(FeedbackSnackbarComponent, { data: { message: "message" } });

  snackbarRef.instance.message = "updated message";
  snackbarRef.instance.dismissAfter(3000);
  snackbarRef.dismiss();
 */

import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'feedback-snackbar',
  templateUrl: './feedback-snackbar.component.html',
  styleUrls: ['./feedback-snackbar.component.css']
})
export class FeedbackSnackbarComponent {
  public message: string;

  constructor(
    private snackbarRef: MatSnackBarRef<FeedbackSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) private data: { message: string },
  ) {
    this.message = data.message;
  }

  public dismissAfter(ms: number) {
    setTimeout(() => this.snackbarRef.dismiss(), ms)
  }
}